import { gql } from '@apollo/client';
import AWAITING_UPLOAD_DEVICES_FRAGMENT from '../fragments/awaitingUploadDevices';

const AWAITING_UPLOAD_DEVICES_QUERY = gql`
  query callCenterStudies($filter: CallCenterStudyFilterInput, $limit: Int) {
    callCenterStudies(filter: $filter, limit: $limit) {
      ...AwaitingUploadDevicesFragment
    }
  }

  ${AWAITING_UPLOAD_DEVICES_FRAGMENT}
`;

export default AWAITING_UPLOAD_DEVICES_QUERY;
